import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const PricingPage = lazy(() => import('../pages/pricing/page'));
const SpeedAgilityPage = lazy(() => import('../pages/speed-agility/page'));
const PillarsPage = lazy(() => import('../pages/pillars/page'));
const PackageDetailsPage = lazy(() => import('../pages/package-details/page'));
const AddonDetailsPage = lazy(() => import('../pages/addon-details/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/pricing',
    element: <PricingPage />,
  },
  {
    path: '/speed-agility',
    element: <SpeedAgilityPage />,
  },
  {
    path: '/pillars',
    element: <PillarsPage />,
  },
  {
    path: '/package/:id',
    element: <PackageDetailsPage />,
  },
  {
    path: '/addon/:id',
    element: <AddonDetailsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
